<template>
  <translate v-show="isCampsiteNew" class="new-campsite"> New </translate>
</template>
<script setup lang="ts">
import { daysBetween } from '~/utility/date/relative'

const props = defineProps<{
  firstAvailableDate: string
}>()

const {
  public: { defaultMaximumNewCampsiteDays },
} = useRuntimeConfig()

const isCampsiteNew = computed<boolean>(() => {
  return (
    daysBetween(props.firstAvailableDate) <=
    Number(defaultMaximumNewCampsiteDays)
  )
})
</script>
<style scoped>
.new-campsite {
  background-color: var(--colour-red);
  border-radius: 0 0.3em 0.3em 0;
  color: white;
  display: inline-block;
  font-size: var(--body);
  font-weight: bold;
  left: 0;
  padding: 0.2em 0.5em;
  position: absolute;
  text-transform: uppercase;
  top: 1.3em;
  z-index: 2;
}
</style>
